@file:OptIn(InternalResourceApi::class)

package crossly.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/crossly.shared.generated.resources/"

@delegate:ResourceContentHash(1_119_692_627)
internal val Res.string.notif_soft_ask_body: StringResource by lazy {
      StringResource("string:notif_soft_ask_body", "notif_soft_ask_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10899, 159),
      ))
    }

@delegate:ResourceContentHash(-2_066_307_446)
internal val Res.string.notif_soft_ask_cta: StringResource by lazy {
      StringResource("string:notif_soft_ask_cta", "notif_soft_ask_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11059, 50),
      ))
    }

@delegate:ResourceContentHash(-922_188_830)
internal val Res.string.notif_soft_ask_dismiss: StringResource by lazy {
      StringResource("string:notif_soft_ask_dismiss", "notif_soft_ask_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11110, 42),
      ))
    }

@delegate:ResourceContentHash(-463_714_792)
internal val Res.string.notif_soft_ask_title: StringResource by lazy {
      StringResource("string:notif_soft_ask_title", "notif_soft_ask_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11153, 64),
      ))
    }

@delegate:ResourceContentHash(1_701_511_620)
internal val Res.string.notif_streak_at_risk_body: StringResource by lazy {
      StringResource("string:notif_streak_at_risk_body", "notif_streak_at_risk_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11218, 85),
      ))
    }

@delegate:ResourceContentHash(1_407_251_349)
internal val Res.string.notif_streak_at_risk_title: StringResource by lazy {
      StringResource("string:notif_streak_at_risk_title", "notif_streak_at_risk_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11304, 78),
      ))
    }

@delegate:ResourceContentHash(-964_810_128)
internal val Res.string.notif_streak_count_body: StringResource by lazy {
      StringResource("string:notif_streak_count_body", "notif_streak_count_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11383, 107),
      ))
    }

@delegate:ResourceContentHash(37_674_375)
internal val Res.string.notif_streak_restore_body: StringResource by lazy {
      StringResource("string:notif_streak_restore_body", "notif_streak_restore_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11491, 109),
      ))
    }

@delegate:ResourceContentHash(1_255_352_852)
internal val Res.string.notif_streak_restore_title: StringResource by lazy {
      StringResource("string:notif_streak_restore_title", "notif_streak_restore_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11601, 78),
      ))
    }

@delegate:ResourceContentHash(1_380_475_594)
internal val Res.string.profile_name_hint: StringResource by lazy {
      StringResource("string:profile_name_hint", "profile_name_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11680, 37),
      ))
    }

@delegate:ResourceContentHash(-144_498_343)
internal val Res.string.profile_name_needed: StringResource by lazy {
      StringResource("string:profile_name_needed", "profile_name_needed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11718, 59),
      ))
    }

@delegate:ResourceContentHash(37_235_736)
internal val Res.string.profile_name_skip: StringResource by lazy {
      StringResource("string:profile_name_skip", "profile_name_skip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11778, 41),
      ))
    }

@delegate:ResourceContentHash(283_879_409)
internal val Res.string.profile_name_title: StringResource by lazy {
      StringResource("string:profile_name_title", "profile_name_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11820, 58),
      ))
    }

@delegate:ResourceContentHash(-1_693_744_787)
internal val Res.string.rarity_common: StringResource by lazy {
      StringResource("string:rarity_common", "rarity_common", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11879, 29),
      ))
    }

@delegate:ResourceContentHash(-331_801_966)
internal val Res.string.rarity_epic: StringResource by lazy {
      StringResource("string:rarity_epic", "rarity_epic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11909, 27),
      ))
    }

@delegate:ResourceContentHash(2_008_147_816)
internal val Res.string.rarity_legendary: StringResource by lazy {
      StringResource("string:rarity_legendary", "rarity_legendary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11937, 36),
      ))
    }

@delegate:ResourceContentHash(-2_112_775_870)
internal val Res.string.rarity_rare: StringResource by lazy {
      StringResource("string:rarity_rare", "rarity_rare", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11974, 27),
      ))
    }

@delegate:ResourceContentHash(1_875_058_432)
internal val Res.string.reset_item_badges: StringResource by lazy {
      StringResource("string:reset_item_badges", "reset_item_badges", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12002, 61),
      ))
    }

@delegate:ResourceContentHash(-1_840_047_401)
internal val Res.string.reset_item_cannot_undo: StringResource by lazy {
      StringResource("string:reset_item_cannot_undo", "reset_item_cannot_undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12064, 62),
      ))
    }

@delegate:ResourceContentHash(133_380_202)
internal val Res.string.reset_item_stars: StringResource by lazy {
      StringResource("string:reset_item_stars", "reset_item_stars", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12127, 88),
      ))
    }

@delegate:ResourceContentHash(2_050_797_135)
internal val Res.string.reset_item_streak: StringResource by lazy {
      StringResource("string:reset_item_streak", "reset_item_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12299, 77),
      ))
    }

@delegate:ResourceContentHash(441_127_462)
internal val Res.string.reset_item_streak_none: StringResource by lazy {
      StringResource("string:reset_item_streak_none", "reset_item_streak_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12216, 82),
      ))
    }

@delegate:ResourceContentHash(1_021_712_970)
internal val Res.string.restore_ad_failed: StringResource by lazy {
      StringResource("string:restore_ad_failed", "restore_ad_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12377, 101),
      ))
    }

@delegate:ResourceContentHash(-1_617_479_184)
internal val Res.string.restore_body_many: StringResource by lazy {
      StringResource("string:restore_body_many", "restore_body_many", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12479, 101),
      ))
    }

@delegate:ResourceContentHash(1_617_463_491)
internal val Res.string.restore_body_one: StringResource by lazy {
      StringResource("string:restore_body_one", "restore_body_one", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12581, 92),
      ))
    }

@delegate:ResourceContentHash(-1_509_332_844)
internal val Res.string.restore_expires: StringResource by lazy {
      StringResource("string:restore_expires", "restore_expires", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12674, 55),
      ))
    }

@delegate:ResourceContentHash(-929_402_401)
internal val Res.string.restore_free: StringResource by lazy {
      StringResource("string:restore_free", "restore_free", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12730, 44),
      ))
    }

@delegate:ResourceContentHash(1_286_064_577)
internal val Res.string.restore_kicker: StringResource by lazy {
      StringResource("string:restore_kicker", "restore_kicker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12775, 42),
      ))
    }

@delegate:ResourceContentHash(-1_252_330_657)
internal val Res.string.restore_not_now: StringResource by lazy {
      StringResource("string:restore_not_now", "restore_not_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12818, 35),
      ))
    }

@delegate:ResourceContentHash(-115_156_322)
internal val Res.string.restore_progress: StringResource by lazy {
      StringResource("string:restore_progress", "restore_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12854, 48),
      ))
    }

@delegate:ResourceContentHash(18_442_291)
internal val Res.string.restore_stars_balance: StringResource by lazy {
      StringResource("string:restore_stars_balance", "restore_stars_balance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12903, 53),
      ))
    }

@delegate:ResourceContentHash(-1_150_304_801)
internal val Res.string.restore_success_body: StringResource by lazy {
      StringResource("string:restore_success_body", "restore_success_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12957, 80),
      ))
    }

@delegate:ResourceContentHash(-2_050_701_398)
internal val Res.string.restore_success_title: StringResource by lazy {
      StringResource("string:restore_success_title", "restore_success_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13038, 53),
      ))
    }

@delegate:ResourceContentHash(-1_640_922_865)
internal val Res.string.restore_title: StringResource by lazy {
      StringResource("string:restore_title", "restore_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13092, 57),
      ))
    }

@delegate:ResourceContentHash(206_421_608)
internal val Res.string.restore_unavailable: StringResource by lazy {
      StringResource("string:restore_unavailable", "restore_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13150, 99),
      ))
    }

@delegate:ResourceContentHash(41_768_388)
internal val Res.string.restore_use_stars: StringResource by lazy {
      StringResource("string:restore_use_stars", "restore_use_stars", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13250, 53),
      ))
    }

@delegate:ResourceContentHash(1_508_533_929)
internal val Res.string.restore_watch_ad: StringResource by lazy {
      StringResource("string:restore_watch_ad", "restore_watch_ad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13304, 40),
      ))
    }

@delegate:ResourceContentHash(1_920_757_455)
internal val Res.string.results_back_to_home: StringResource by lazy {
      StringResource("string:results_back_to_home", "results_back_to_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13345, 44),
      ))
    }

@delegate:ResourceContentHash(542_369_198)
internal val Res.string.results_back_to_levels: StringResource by lazy {
      StringResource("string:results_back_to_levels", "results_back_to_levels", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13390, 50),
      ))
    }

@delegate:ResourceContentHash(-1_859_905_295)
internal val Res.string.results_challenge_another: StringResource by lazy {
      StringResource("string:results_challenge_another", "results_challenge_another", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13441, 65),
      ))
    }

@delegate:ResourceContentHash(405_761_434)
internal val Res.string.results_challenge_friend: StringResource by lazy {
      StringResource("string:results_challenge_friend", "results_challenge_friend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13507, 56),
      ))
    }

@delegate:ResourceContentHash(935_661_970)
internal val Res.string.results_daily_streak: StringResource by lazy {
      StringResource("string:results_daily_streak", "results_daily_streak", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13564, 44),
      ))
    }

@delegate:ResourceContentHash(453_887_696)
internal val Res.string.results_lost: StringResource by lazy {
      StringResource("string:results_lost", "results_lost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13665, 32),
      ))
    }

@delegate:ResourceContentHash(214_157_010)
internal val Res.string.results_lost_by: StringResource by lazy {
      StringResource("string:results_lost_by", "results_lost_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13609, 55),
      ))
    }

@delegate:ResourceContentHash(2_049_820_272)
internal val Res.string.results_next_level: StringResource by lazy {
      StringResource("string:results_next_level", "results_next_level", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13698, 42),
      ))
    }

@delegate:ResourceContentHash(1_916_221_687)
internal val Res.string.results_play_again: StringResource by lazy {
      StringResource("string:results_play_again", "results_play_again", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13741, 42),
      ))
    }

@delegate:ResourceContentHash(1_448_315_960)
internal val Res.string.results_rank_flawless: StringResource by lazy {
      StringResource("string:results_rank_flawless", "results_rank_flawless", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13869, 41),
      ))
    }

@delegate:ResourceContentHash(1_388_735_697)
internal val Res.string.results_rank_flawless_detail: StringResource by lazy {
      StringResource("string:results_rank_flawless_detail", "results_rank_flawless_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13784, 84),
      ))
    }

@delegate:ResourceContentHash(-1_299_557_551)
internal val Res.string.results_rank_great: StringResource by lazy {
      StringResource("string:results_rank_great", "results_rank_great", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13993, 42),
      ))
    }

@delegate:ResourceContentHash(2_055_943_935)
internal val Res.string.results_rank_great_detail: StringResource by lazy {
      StringResource("string:results_rank_great_detail", "results_rank_great_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13911, 81),
      ))
    }

@delegate:ResourceContentHash(1_417_846_909)
internal val Res.string.results_rank_solved: StringResource by lazy {
      StringResource("string:results_rank_solved", "results_rank_solved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14127, 39),
      ))
    }

@delegate:ResourceContentHash(836_648_780)
internal val Res.string.results_rank_solved_detail: StringResource by lazy {
      StringResource("string:results_rank_solved_detail", "results_rank_solved_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14036, 90),
      ))
    }

@delegate:ResourceContentHash(-1_024_546_618)
internal val Res.string.results_share_with: StringResource by lazy {
      StringResource("string:results_share_with", "results_share_with", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14167, 46),
      ))
    }

@delegate:ResourceContentHash(476_392_909)
internal val Res.string.results_stars_earned: StringResource by lazy {
      StringResource("string:results_stars_earned", "results_stars_earned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14214, 52),
      ))
    }

@delegate:ResourceContentHash(-1_760_445_234)
internal val Res.string.results_tie: StringResource by lazy {
      StringResource("string:results_tie", "results_tie", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14267, 35),
      ))
    }

@delegate:ResourceContentHash(-1_808_843_654)
internal val Res.string.results_time_taken: StringResource by lazy {
      StringResource("string:results_time_taken", "results_time_taken", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14303, 50),
      ))
    }

@delegate:ResourceContentHash(-848_767_590)
internal val Res.string.results_title: StringResource by lazy {
      StringResource("string:results_title", "results_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14354, 45),
      ))
    }

@delegate:ResourceContentHash(768_830_088)
internal val Res.string.results_won: StringResource by lazy {
      StringResource("string:results_won", "results_won", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14451, 31),
      ))
    }

@delegate:ResourceContentHash(-1_980_837_769)
internal val Res.string.results_won_by: StringResource by lazy {
      StringResource("string:results_won_by", "results_won_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14400, 50),
      ))
    }

@delegate:ResourceContentHash(1_966_764_368)
internal val Res.string.save_progress_body: StringResource by lazy {
      StringResource("string:save_progress_body", "save_progress_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14483, 138),
      ))
    }

@delegate:ResourceContentHash(1_785_959_478)
internal val Res.string.save_progress_discard: StringResource by lazy {
      StringResource("string:save_progress_discard", "save_progress_discard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14622, 41),
      ))
    }

@delegate:ResourceContentHash(-1_078_292_232)
internal val Res.string.save_progress_save: StringResource by lazy {
      StringResource("string:save_progress_save", "save_progress_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14664, 50),
      ))
    }

@delegate:ResourceContentHash(-1_871_423_499)
internal val Res.string.save_progress_title: StringResource by lazy {
      StringResource("string:save_progress_title", "save_progress_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14715, 55),
      ))
    }

@delegate:ResourceContentHash(94_737_716)
internal val Res.string.settings_ads_free_active: StringResource by lazy {
      StringResource("string:settings_ads_free_active", "settings_ads_free_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14771, 92),
      ))
    }

@delegate:ResourceContentHash(-292_345_136)
internal val Res.string.settings_ads_remove: StringResource by lazy {
      StringResource("string:settings_ads_remove", "settings_ads_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14956, 43),
      ))
    }

@delegate:ResourceContentHash(1_368_373_329)
internal val Res.string.settings_ads_remove_summary: StringResource by lazy {
      StringResource("string:settings_ads_remove_summary", "settings_ads_remove_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14864, 91),
      ))
    }

@delegate:ResourceContentHash(558_345_074)
internal val Res.string.settings_ads_restore: StringResource by lazy {
      StringResource("string:settings_ads_restore", "settings_ads_restore", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15094, 52),
      ))
    }

@delegate:ResourceContentHash(-133_838_510)
internal val Res.string.settings_ads_restore_none: StringResource by lazy {
      StringResource("string:settings_ads_restore_none", "settings_ads_restore_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15000, 93),
      ))
    }

@delegate:ResourceContentHash(1_121_096_144)
internal val Res.string.settings_clue_gutter: StringResource by lazy {
      StringResource("string:settings_clue_gutter", "settings_clue_gutter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15288, 56),
      ))
    }

@delegate:ResourceContentHash(-1_702_062_996)
internal val Res.string.settings_clue_gutter_summary: StringResource by lazy {
      StringResource("string:settings_clue_gutter_summary", "settings_clue_gutter_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15147, 140),
      ))
    }

@delegate:ResourceContentHash(182_164_115)
internal val Res.string.settings_coach_marks: StringResource by lazy {
      StringResource("string:settings_coach_marks", "settings_coach_marks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15598, 44),
      ))
    }

@delegate:ResourceContentHash(520_348_650)
internal val Res.string.settings_coach_marks_queued: StringResource by lazy {
      StringResource("string:settings_coach_marks_queued", "settings_coach_marks_queued", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15345, 63),
      ))
    }

@delegate:ResourceContentHash(-475_783_608)
internal val Res.string.settings_coach_marks_replay: StringResource by lazy {
      StringResource("string:settings_coach_marks_replay", "settings_coach_marks_replay", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15409, 67),
      ))
    }

@delegate:ResourceContentHash(285_043_701)
internal val Res.string.settings_coach_marks_summary: StringResource by lazy {
      StringResource("string:settings_coach_marks_summary", "settings_coach_marks_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15477, 120),
      ))
    }

@delegate:ResourceContentHash(1_115_064_223)
internal val Res.string.settings_crashlytics_test: StringResource by lazy {
      StringResource("string:settings_crashlytics_test", "settings_crashlytics_test", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15643, 65),
      ))
    }

@delegate:ResourceContentHash(298_084_300)
internal val Res.string.settings_keyboard: StringResource by lazy {
      StringResource("string:settings_keyboard", "settings_keyboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16066, 41),
      ))
    }

@delegate:ResourceContentHash(-1_413_896_571)
internal val Res.string.settings_keyboard_full: StringResource by lazy {
      StringResource("string:settings_keyboard_full", "settings_keyboard_full", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15709, 38),
      ))
    }

@delegate:ResourceContentHash(-726_369_612)
internal val Res.string.settings_keyboard_relevant: StringResource by lazy {
      StringResource("string:settings_keyboard_relevant", "settings_keyboard_relevant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15748, 50),
      ))
    }

@delegate:ResourceContentHash(-547_439_491)
internal val Res.string.settings_keyboard_summary: StringResource by lazy {
      StringResource("string:settings_keyboard_summary", "settings_keyboard_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15799, 169),
      ))
    }

@delegate:ResourceContentHash(-1_844_920_859)
internal val Res.string.settings_keyboard_this_puzzle: StringResource by lazy {
      StringResource("string:settings_keyboard_this_puzzle", "settings_keyboard_this_puzzle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15969, 53),
      ))
    }

@delegate:ResourceContentHash(-1_654_399_150)
internal val Res.string.settings_keyboard_word: StringResource by lazy {
      StringResource("string:settings_keyboard_word", "settings_keyboard_word", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16023, 42),
      ))
    }

@delegate:ResourceContentHash(-1_709_909_437)
internal val Res.string.settings_notifications: StringResource by lazy {
      StringResource("string:settings_notifications", "settings_notifications", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16231, 50),
      ))
    }

@delegate:ResourceContentHash(-1_481_258_513)
internal val Res.string.settings_notifications_summary: StringResource by lazy {
      StringResource("string:settings_notifications_summary", "settings_notifications_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16108, 122),
      ))
    }

@delegate:ResourceContentHash(-2_089_088_991)
internal val Res.string.settings_palette_classic: StringResource by lazy {
      StringResource("string:settings_palette_classic", "settings_palette_classic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16282, 44),
      ))
    }

@delegate:ResourceContentHash(894_936_414)
internal val Res.string.settings_palette_neon: StringResource by lazy {
      StringResource("string:settings_palette_neon", "settings_palette_neon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16327, 37),
      ))
    }

@delegate:ResourceContentHash(-166_725_405)
internal val Res.string.settings_palette_ocean: StringResource by lazy {
      StringResource("string:settings_palette_ocean", "settings_palette_ocean", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16365, 38),
      ))
    }

@delegate:ResourceContentHash(-1_593_770_394)
internal val Res.string.settings_palette_sunset: StringResource by lazy {
      StringResource("string:settings_palette_sunset", "settings_palette_sunset", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16404, 39),
      ))
    }

@delegate:ResourceContentHash(1_380_475_594)
internal val Res.string.settings_player_name: StringResource by lazy {
      StringResource("string:settings_player_name", "settings_player_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16596, 40),
      ))
    }

@delegate:ResourceContentHash(-192_775_048)
internal val Res.string.settings_player_name_summary: StringResource by lazy {
      StringResource("string:settings_player_name_summary", "settings_player_name_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16444, 104),
      ))
    }

@delegate:ResourceContentHash(671_756_522)
internal val Res.string.settings_player_name_unset: StringResource by lazy {
      StringResource("string:settings_player_name_unset", "settings_player_name_unset", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16549, 46),
      ))
    }

@delegate:ResourceContentHash(-511_232_521)
internal val Res.string.settings_privacy_policy: StringResource by lazy {
      StringResource("string:settings_privacy_policy", "settings_privacy_policy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16725, 51),
      ))
    }

@delegate:ResourceContentHash(-328_028_069)
internal val Res.string.settings_privacy_policy_summary: StringResource by lazy {
      StringResource("string:settings_privacy_policy_summary", "settings_privacy_policy_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16637, 87),
      ))
    }

@delegate:ResourceContentHash(-1_990_692_278)
internal val Res.string.settings_reset_progress: StringResource by lazy {
      StringResource("string:settings_reset_progress", "settings_reset_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16981, 51),
      ))
    }

@delegate:ResourceContentHash(-1_212_561_733)
internal val Res.string.settings_reset_progress_confirm: StringResource by lazy {
      StringResource("string:settings_reset_progress_confirm", "settings_reset_progress_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16777, 99),
      ))
    }

@delegate:ResourceContentHash(-976_190_644)
internal val Res.string.settings_reset_progress_summary: StringResource by lazy {
      StringResource("string:settings_reset_progress_summary", "settings_reset_progress_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16877, 103),
      ))
    }

@delegate:ResourceContentHash(1_030_518_166)
internal val Res.string.settings_restart_note: StringResource by lazy {
      StringResource("string:settings_restart_note", "settings_restart_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17033, 109),
      ))
    }

@delegate:ResourceContentHash(2_499_342)
internal val Res.string.settings_section_ads: StringResource by lazy {
      StringResource("string:settings_section_ads", "settings_section_ads", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17143, 32),
      ))
    }

@delegate:ResourceContentHash(2_499_804)
internal val Res.string.settings_section_app: StringResource by lazy {
      StringResource("string:settings_section_app", "settings_section_app", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17176, 32),
      ))
    }

@delegate:ResourceContentHash(1_371_242_364)
internal val Res.string.settings_section_data: StringResource by lazy {
      StringResource("string:settings_section_data", "settings_section_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17209, 41),
      ))
    }

@delegate:ResourceContentHash(-37_871_017)
internal val Res.string.settings_section_look: StringResource by lazy {
      StringResource("string:settings_section_look", "settings_section_look", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17251, 49),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("notif_soft_ask_body", Res.string.notif_soft_ask_body)
  map.put("notif_soft_ask_cta", Res.string.notif_soft_ask_cta)
  map.put("notif_soft_ask_dismiss", Res.string.notif_soft_ask_dismiss)
  map.put("notif_soft_ask_title", Res.string.notif_soft_ask_title)
  map.put("notif_streak_at_risk_body", Res.string.notif_streak_at_risk_body)
  map.put("notif_streak_at_risk_title", Res.string.notif_streak_at_risk_title)
  map.put("notif_streak_count_body", Res.string.notif_streak_count_body)
  map.put("notif_streak_restore_body", Res.string.notif_streak_restore_body)
  map.put("notif_streak_restore_title", Res.string.notif_streak_restore_title)
  map.put("profile_name_hint", Res.string.profile_name_hint)
  map.put("profile_name_needed", Res.string.profile_name_needed)
  map.put("profile_name_skip", Res.string.profile_name_skip)
  map.put("profile_name_title", Res.string.profile_name_title)
  map.put("rarity_common", Res.string.rarity_common)
  map.put("rarity_epic", Res.string.rarity_epic)
  map.put("rarity_legendary", Res.string.rarity_legendary)
  map.put("rarity_rare", Res.string.rarity_rare)
  map.put("reset_item_badges", Res.string.reset_item_badges)
  map.put("reset_item_cannot_undo", Res.string.reset_item_cannot_undo)
  map.put("reset_item_stars", Res.string.reset_item_stars)
  map.put("reset_item_streak", Res.string.reset_item_streak)
  map.put("reset_item_streak_none", Res.string.reset_item_streak_none)
  map.put("restore_ad_failed", Res.string.restore_ad_failed)
  map.put("restore_body_many", Res.string.restore_body_many)
  map.put("restore_body_one", Res.string.restore_body_one)
  map.put("restore_expires", Res.string.restore_expires)
  map.put("restore_free", Res.string.restore_free)
  map.put("restore_kicker", Res.string.restore_kicker)
  map.put("restore_not_now", Res.string.restore_not_now)
  map.put("restore_progress", Res.string.restore_progress)
  map.put("restore_stars_balance", Res.string.restore_stars_balance)
  map.put("restore_success_body", Res.string.restore_success_body)
  map.put("restore_success_title", Res.string.restore_success_title)
  map.put("restore_title", Res.string.restore_title)
  map.put("restore_unavailable", Res.string.restore_unavailable)
  map.put("restore_use_stars", Res.string.restore_use_stars)
  map.put("restore_watch_ad", Res.string.restore_watch_ad)
  map.put("results_back_to_home", Res.string.results_back_to_home)
  map.put("results_back_to_levels", Res.string.results_back_to_levels)
  map.put("results_challenge_another", Res.string.results_challenge_another)
  map.put("results_challenge_friend", Res.string.results_challenge_friend)
  map.put("results_daily_streak", Res.string.results_daily_streak)
  map.put("results_lost", Res.string.results_lost)
  map.put("results_lost_by", Res.string.results_lost_by)
  map.put("results_next_level", Res.string.results_next_level)
  map.put("results_play_again", Res.string.results_play_again)
  map.put("results_rank_flawless", Res.string.results_rank_flawless)
  map.put("results_rank_flawless_detail", Res.string.results_rank_flawless_detail)
  map.put("results_rank_great", Res.string.results_rank_great)
  map.put("results_rank_great_detail", Res.string.results_rank_great_detail)
  map.put("results_rank_solved", Res.string.results_rank_solved)
  map.put("results_rank_solved_detail", Res.string.results_rank_solved_detail)
  map.put("results_share_with", Res.string.results_share_with)
  map.put("results_stars_earned", Res.string.results_stars_earned)
  map.put("results_tie", Res.string.results_tie)
  map.put("results_time_taken", Res.string.results_time_taken)
  map.put("results_title", Res.string.results_title)
  map.put("results_won", Res.string.results_won)
  map.put("results_won_by", Res.string.results_won_by)
  map.put("save_progress_body", Res.string.save_progress_body)
  map.put("save_progress_discard", Res.string.save_progress_discard)
  map.put("save_progress_save", Res.string.save_progress_save)
  map.put("save_progress_title", Res.string.save_progress_title)
  map.put("settings_ads_free_active", Res.string.settings_ads_free_active)
  map.put("settings_ads_remove", Res.string.settings_ads_remove)
  map.put("settings_ads_remove_summary", Res.string.settings_ads_remove_summary)
  map.put("settings_ads_restore", Res.string.settings_ads_restore)
  map.put("settings_ads_restore_none", Res.string.settings_ads_restore_none)
  map.put("settings_clue_gutter", Res.string.settings_clue_gutter)
  map.put("settings_clue_gutter_summary", Res.string.settings_clue_gutter_summary)
  map.put("settings_coach_marks", Res.string.settings_coach_marks)
  map.put("settings_coach_marks_queued", Res.string.settings_coach_marks_queued)
  map.put("settings_coach_marks_replay", Res.string.settings_coach_marks_replay)
  map.put("settings_coach_marks_summary", Res.string.settings_coach_marks_summary)
  map.put("settings_crashlytics_test", Res.string.settings_crashlytics_test)
  map.put("settings_keyboard", Res.string.settings_keyboard)
  map.put("settings_keyboard_full", Res.string.settings_keyboard_full)
  map.put("settings_keyboard_relevant", Res.string.settings_keyboard_relevant)
  map.put("settings_keyboard_summary", Res.string.settings_keyboard_summary)
  map.put("settings_keyboard_this_puzzle", Res.string.settings_keyboard_this_puzzle)
  map.put("settings_keyboard_word", Res.string.settings_keyboard_word)
  map.put("settings_notifications", Res.string.settings_notifications)
  map.put("settings_notifications_summary", Res.string.settings_notifications_summary)
  map.put("settings_palette_classic", Res.string.settings_palette_classic)
  map.put("settings_palette_neon", Res.string.settings_palette_neon)
  map.put("settings_palette_ocean", Res.string.settings_palette_ocean)
  map.put("settings_palette_sunset", Res.string.settings_palette_sunset)
  map.put("settings_player_name", Res.string.settings_player_name)
  map.put("settings_player_name_summary", Res.string.settings_player_name_summary)
  map.put("settings_player_name_unset", Res.string.settings_player_name_unset)
  map.put("settings_privacy_policy", Res.string.settings_privacy_policy)
  map.put("settings_privacy_policy_summary", Res.string.settings_privacy_policy_summary)
  map.put("settings_reset_progress", Res.string.settings_reset_progress)
  map.put("settings_reset_progress_confirm", Res.string.settings_reset_progress_confirm)
  map.put("settings_reset_progress_summary", Res.string.settings_reset_progress_summary)
  map.put("settings_restart_note", Res.string.settings_restart_note)
  map.put("settings_section_ads", Res.string.settings_section_ads)
  map.put("settings_section_app", Res.string.settings_section_app)
  map.put("settings_section_data", Res.string.settings_section_data)
  map.put("settings_section_look", Res.string.settings_section_look)
}
